/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useCallback, useState, useRef } from 'react'
import {
	Divider,
	Flex,
	Text,
	IconButton,
	Box,
	Image,
	useDisclosure,
} from '@chakra-ui/react'
import { useAuthContext } from '../../../../context/auth.context'
import { useSharedContext } from '../../../../context/shared.context'
import { usePubNub } from 'pubnub-react'
import Card from '../../../card'
import { MdSend } from 'react-icons/md'
import { CHAT_PANEL_VIEW } from '../indes'
import SingleMessage from '../SingleMessage'
import profile from '../../../../assets/images/profile.png'
import group from '../../../../assets/images/group_icon.png'
import {
	useLoadGroupParticipants,
	useAlterFileCover,
	useAddTimelineUpdate,
	useRemoveParticipant,
	useInviteParticipant,
} from '../../../../hooks/activity.hooks'
import {
	formatDueDateForTimelineCurrDate,
	formatNoteUpdateDate,
	formatDDMMYYYY,
} from '../../../../utils/date.utils'
import GroupList from '../GroupList'
import { sharedConst } from '../../../../utils/action.constant'
import { LoadChatData } from '../../../../hooks/asset.hooks'
import {
	getCurrentDateUTC,
	getMessageUniqueId,
} from '../../../../utils/common.util'
import {
	dataLayerTagManager,
	sectionDetailedTrack,
} from '../../../../containers/repository/repo.utils'
import { GA_CATEGORY_NAVBAR } from './../../../../containers/repository/repo.utils'
import { useLanguageContext } from '../../../../context/locale.context'
import bgImage from '../../../../assets/images/opaque_bgImage.png'
import { getFromNow, formatChatGroupBy } from '../../../../utils/date.utils'
import InputText from '../../../globalComponents/inputText'
import ButtonCTA from '../../../globalComponents/button'
import { ImAttachment } from 'react-icons/im'
import { pushFileToS3, loadAwsFile } from '../../../../utils/aws.util'
import { BsX } from 'react-icons/bs'
import { useDeepStreamContext } from '../../../../context/deepstream.context'
import { formatHHMM } from '../../../../utils/date.utils'
import { useLoadCoWorkersList } from '../../../../hooks/shared.hooks'
import { ParticipantDrawer } from '../../../globalComponents/participantDrawer'
import SVGIcon from '../../../../assets/svgIcons'

export const GROUP_PANEL_VIEW = {
	GROUP_CHAT_VIEW: 'GROUP_CHAT_VIEW',
	GROUP_INFO_VIEW: 'GROUP_INFO_VIEW',
}

const CreateGroupView = ({
	setchatView,
	onChatClose,
	chatView,
	user,
	chatData,
	onMessageSubmit,
	setisNewChat,
	isNewChat,
	onProfileSelection,
	setchatData,
	setselectedProfile,
	selectedProfile,
	isFromGroup,
	chatInitializer,
	setGrouplistCount,
}) => {
	const [chanelName, setchanelName] = useState('')
	const [userName, setUserName] = useState('')
	const [message, setmessage] = useState('')
	const [onlineStatus, setonlineStatus] = useState('')
	const messagesEndRef = useRef(null)
	const [groupUsers, setgroupUsers] = useState([])
	const [groupList, setGroupList] = useState([])
	const [dummy, setdummy] = useState(true)
	const { mutate: loadParticipant } = useLoadGroupParticipants()
	const [groupView, setgroupView] = useState('')
	const [isGroupEdit, setisGroupEdit] = useState(false)
	const [groupName, setGroupName] = useState('')
	const [profileImageData, setProfileImageData] = useState('')
	const { isOpen, onToggle } = useDisclosure()
	const [attachmentURl, setattachmentURl] = useState('')
	const [isGroupCreated, setIsGroupCreated] = useState(false)
	const [isGroupNameSubmitted, setIsGroupNameSubmitted] = useState(false)
	const [isGroupChat, setisGroupChat] = useState(false)
	const [isSerchChange, setisSerchChange] = useState(false)
	const [serchString, setserchString] = useState('')
	const [isGroupNameEntered, setIsGroupNameEntered] = useState(false)
	const [participantData, setParticipantData] = useState([])
	const [selectedParticipants, setSelectedParticipants] = useState([])
	const [openAddParticipants, setOpenAddParticipants] = useState(false)
	const {
		isOpen: addParticipantFormIsOpen,
		onOpen: addParticipantOnOpen,
		onClose: addParticipantOnClose,
	} = useDisclosure()

	const {
		state: { authData },
	} = useAuthContext()
	const {
		state: { locale },
	} = useLanguageContext()
	const {
		state: { ds },
	} = useDeepStreamContext()
	const { mutate: inviteMutate } = useInviteParticipant()
	const { mutate: mutateFileEditSave, isLoading: isActivityUpdating } =
		useAlterFileCover()
	const { mutate: mutateaddTimeLineUpdate } = useAddTimelineUpdate()
	const { mutate: loadChatData } = LoadChatData()
	const { mutate: removeMutate } = useRemoveParticipant()
	const { state, dispatch } = useSharedContext()
	const { isRefreshChat, chatSelectedProfile } = state || {}
	const inputRef = useRef()
	const pubnub = usePubNub()
	const { mutate: mutateLoadCoWorkers } = useLoadCoWorkersList()
	const goBack = () => {
		if (groupView === GROUP_PANEL_VIEW.GROUP_INFO_VIEW) {
			setgroupView('')
			setisGroupEdit(false)
		} else {
			setchatView(CHAT_PANEL_VIEW.LIST_VIEW)
			setchatData([])
		}
	}

	useEffect(() => {
		onProfileSelection(chatSelectedProfile)
	}, [isRefreshChat])

	useEffect(() => {
		onSerch()
	}, [])

	useEffect(() => {
		if (groupView === GROUP_PANEL_VIEW.GROUP_INFO_VIEW) {
			setgroupView('')
			setisGroupEdit(false)
		}
		toGetChatTitle()
		if (
			!!ds &&
			Object.keys(chatSelectedProfile).length > 0 &&
			!chatSelectedProfile?.isGroupChat
		) {
			if (!!ds && chatSelectedProfile?.activity_type_category_id !== 27)
				toShowStatus()
		}
	}, [chatSelectedProfile, ds])

	useEffect(() => {
		messagesEndRef.current?.scrollIntoView()
	}, [chatData, groupView])

	const toShowStatus = () => {
		let ChannelName = ''
		let hereNowUserId = 0
		if (chatSelectedProfile) {
			if (chatSelectedProfile.hasOwnProperty('activity_id')) {
				hereNowUserId = chatSelectedProfile.activity_lead_asset_id
			} else if (chatSelectedProfile.isGroupChat) {
				hereNowUserId = chatSelectedProfile.groupName
			} else {
				hereNowUserId = chatSelectedProfile.value?.contact_asset_id
			}

			ChannelName =
				user.asset_id > chatSelectedProfile.asset_id
					? chatSelectedProfile.asset_id + '-' + user.asset_id
					: user.asset_id + '-' + chatSelectedProfile.asset_id
			if (chatSelectedProfile.hasOwnProperty('activity_id')) {
				ChannelName = chatSelectedProfile.activity_title
			} else {
				ChannelName =
					user.asset_id > chatSelectedProfile.asset_id
						? chatSelectedProfile.asset_id + '-' + user.asset_id
						: user.asset_id + '-' + chatSelectedProfile.asset_id
			}
		}
		pubnub.subscribe({
			channels: [ChannelName],
			withPresence: true,
		})
		ds.event.subscribe(ChannelName, data => {})
		const UserID = hereNowUserId
		if (chatSelectedProfile) {
			// pubnub.getPresence(ChannelName, presence => {
			//   const TypingUser = presence.uuid.split('-')
			//   if (
			//     Number(TypingUser[0]) !== Number(user.asset_id) &&
			//     presence.action === 'state-change'
			//   ) {
			//     // this.setState({
			//     //     ...this.state,
			//     //     userIsTyping: presence.state.isTyping,
			//     // });
			//   }
			// })
			pubnub.whereNow(
				{
					uuid: UserID + '-' + user.organization_id,
				},
				(status, response) => {
					if (
						!!response &&
						!!response.channels &&
						response.channels.length > 0
					) {
						setonlineStatus('Online')
					} else {
						setonlineStatus('Offline')
					}
				}
			)
		}
	}

	const toGetChatTitle = () => {
		let userName = user.operating_asset_first_name
		if (chatSelectedProfile && !isNewChat) {
			let activityTitle = chatSelectedProfile?.activity_title?.split('-')
			if (activityTitle) {
				if (user.asset_id === chatSelectedProfile?.activity_creator_asset_id) {
					userName = activityTitle[1]
				} else {
					userName = activityTitle[0]
				}
			}
			if (chatSelectedProfile.activity_type_category_id === 27) {
				userName = chatSelectedProfile?.activity_title
			}
		}
		let title
		title =
			isNewChat && chatSelectedProfile && chatSelectedProfile.isGroupChat
				? chatSelectedProfile.groupName
				: isNewChat
				? `${userName} - ${
						chatSelectedProfile &&
						chatSelectedProfile.operating_asset_first_name
							? chatSelectedProfile.operating_asset_first_name
							: ''
				  }`
				: chatSelectedProfile && chatSelectedProfile.activity_title
		if (
			chatSelectedProfile.activity_type_category_id === 16 ||
			chatSelectedProfile.activity_type_category_id === 27
		) {
			title = chatSelectedProfile.activity_title
		}
		setchanelName(title)
		setUserName(userName)
	}

	const groupInfo = () => {
		setgroupView(GROUP_PANEL_VIEW.GROUP_INFO_VIEW)
		setGroupName(chanelName)
		loadParticipant(
			{
				activity_id: chatSelectedProfile.activity_id,
				datetime_differential: '1970-01-01 00:00:00',
				limit_value: 50,
				page_limit: 50,
				page_start: 0,
				start_from: 0,
			},
			{
				onSuccess: async data => {
					setgroupUsers(data)
				},
			}
		)
	}

	// downloadAwsFile('https://worlddesk-staging-j21qqcnj.s3.ap-south-1.amazonaws.com/868/1102/5918/39749/2022/11/103/397491669632745361/Screenshot-from-2022-08-25-16-26-28.png')
	const onKeyDown = event => {
		// 'keypress' event misbehaves on mobile so we track 'Enter' key via 'keydown' event
		if (event.key === 'Enter') {
			event.preventDefault()
			event.stopPropagation()
			onMessageSubmit({
				message,
				user: chatSelectedProfile,
				url: attachmentURl,
			})
			setmessage('')
			setattachmentURl('')
		}
	}

	const buildTitleUpdateParams = updatedTitle => {
		const {
			activity_title,
			activity_datetime_end_deferred,
			activity_id,
			activity_type_id,
		} = chatSelectedProfile
		const coverPayload = {
			title: {
				old: activity_title,
				new: updatedTitle,
			},
			description: { old: '', new: '' },
			duedate: {
				old: activity_datetime_end_deferred,
				new: activity_datetime_end_deferred,
			},
		}
		return {
			activity_id: activity_id,
			activity_cover_data: JSON.stringify(coverPayload),
			activity_type_id: activity_type_id,
		}
	}

	const buildTimelineEntryParams = updatedTitle => {
		const {
			activity_title,
			activity_id,
			activity_type_category_id,
			parent_activity_id,
			activity_type_id,
		} = chatSelectedProfile
		const { operating_asset_first_name } = authData
		let activityTimelineJson = {
			content: `Activity title changed from "${
				activity_title ? activity_title : chanelName
			}" to "${updatedTitle}" by ${operating_asset_first_name} @
                ${formatDueDateForTimelineCurrDate()}`,
			subject: 'Note - ' + formatNoteUpdateDate(),
			mail_body: `Activity title changed from "${
				activity_title ? activity_title : chanelName
			}" to "${updatedTitle}" by ${operating_asset_first_name} @
                ${formatDueDateForTimelineCurrDate()}`,
			attachments: [],
			activity_reference: [
				{
					activity_title: '',
					activity_id: '',
				},
			],
			asset_reference: [],
			form_approval_field_reference: [],
		}
		return {
			activity_id: activity_id,
			activity_type_category_id: activity_type_category_id,
			activity_type_id: activity_type_id,
			activity_parent_id: parent_activity_id,
			activity_timeline_collection: JSON.stringify(activityTimelineJson),
			activity_stream_type_id: 711,
			timeline_stream_type_id: 711,
			data_entity_inline: JSON.stringify(activityTimelineJson),
			operating_asset_first_name: operating_asset_first_name,
		}
	}

	//change group name:---
	const onRenameActivity = activityName => {
		if (!activityName) return
		let activity = chatSelectedProfile
		const { activity_title } = chatSelectedProfile
		if (activity_title !== activityName) {
			let titleParams = buildTitleUpdateParams(activityName)
			let timelineParams = buildTimelineEntryParams(activityName)
			mutateFileEditSave(
				{ activity, ...titleParams },
				{
					onSuccess: async () => {
						loadChatData(
							{
								asset_message_counter: 0,
								message_unique_id: 1636353695988,
								track_latitude: 0,
								track_longitude: 0,
								track_altitude: 0,
								track_gps_datetime: getCurrentDateUTC(new Date()),
								track_gps_accuracy: 0,
								track_gps_status: 0,
								page_limit: 50,
								page_start: 0,
							},
							{
								onSuccess: async data => {
									setisGroupEdit(false)
									let selectdValue = data.find(
										val => val.activity_id === chatSelectedProfile.activity_id
									)
									onProfileSelection(selectdValue)
								},
								onError: async err => {
									console.log(err)
								},
							}
						)
						mutateaddTimeLineUpdate(
							{ ...timelineParams },

							{
								onSuccess: async () => {
									dispatch({
										type: sharedConst.REFRESH_CHAT_COUNT,
										isRefreshChat: false,
									})
								},
							}
						)
					},
				}
			)
		}
	}

	const removeParticipant = useCallback(participant => {
		const { activity_id } = chatSelectedProfile
		removeMutate(
			{
				activity_id,
				activity_participant_collection: JSON.stringify([
					{
						...participant,
						access_role_id: 0,
						message_unique_id: getMessageUniqueId(),
					},
				]),
			},
			{
				onSuccess: async data => {
					groupInfo()
				},
				onError: async error => {
					console.log('remove error', error)
				},
			}
		)
	})

	const inviteUser = useCallback(
		({
			// contact_asset_type_id,
			// contact_asset_id,
			// contact_first_name,
			// contact_operating_asset_name,
			asset_type_id,
			asset_id,
			asset_first_name,
			operating_asset_first_name,
			workforce_name,
		}) => {
			const { activity_id, activity_type_id } = chatSelectedProfile
			inviteMutate(
				{
					activity_id,
					activity_type_category_id: 27,
					activity_type_id,
					contact: {
						asset_type_id: asset_type_id,
						asset_id: asset_id,
						asset_first_name: asset_first_name,
						operating_asset_first_name: operating_asset_first_name,
						workforce_name,
					},
				},
				{
					onSuccess: async data => {
						groupInfo()
					},
				}
			)
		}
	)
	// let profileIcon = ''
	// if (selectedProfile?.activity_lead_asset_image_path) {
	//   loadAwsFile(selectedProfile?.activity_lead_asset_image_path, d => {
	//     profileIcon = 'data:' + d.type + ';base64,' + d.data
	//     console.log(
	//       selectedProfile?.activity_lead_asset_image_path,
	//       profileIcon,
	//       'ss1'
	//     )
	//   })
	// }
	useEffect(() => {
		setTimeout(() => {
			if (!!selectedProfile?.activity_lead_asset_image_path) {
				loadAwsFile(selectedProfile?.activity_lead_asset_image_path, d => {
					let imagedata = 'data:' + d.type + ';base64,' + d.data
					setProfileImageData(imagedata)
				})
			}
		}, 1000)
	}, [selectedProfile?.activity_lead_asset_image_path])
	const profileImage = selectedProfile?.activity_lead_asset_image_path
		? profileImageData
		: profile
	const openCloseClick = () => {
		onToggle()
	}

	const onHandleFileChange = async event => {
		const file = event.target['files'][0]
		const blob = file?.slice(0, file.size, file.type)
		const newFile = new File([blob], file.name.replace(/ /gi, '-'), {
			type: blob.type,
		})
		let result = await pushFileToS3(newFile)
		const [{ url }] = await Promise.all([result])

		setattachmentURl(url)
		setmessage(toReturnName(url))
	}

	const clearFiles = () => {
		setattachmentURl('')
		setmessage('')
	}

	const toReturnName = url => {
		return url.split('/').pop()
	}

	const onGoBack = () => {
		// getChatList()
		setserchString('')
		setisNewChat(false)
		setisSerchChange(false)
		setisGroupChat(false)
		setGroupList([])
		setGrouplistCount(0)
		setGroupName('')
		// setShowSearch(false)
	}
	const onGroupCreat = () => {
		setIsGroupNameSubmitted(true)
		if (!groupName) return
		setisNewChat(true)
		setdummy(!dummy)
		setIsGroupNameEntered(true)
		let group = {
			groupName: groupName,
			isGroupChat: true,
			userList: selectedParticipants,
		}
		chatInitializer(group)
		addParticipantOnClose()
		setchatView(CHAT_PANEL_VIEW.CHAT_VIEW)
		onGoBack()
		setisGroupChat(false)
		setGroupList([])
		setGroupName('')
		setIsGroupNameSubmitted(false)
		setisSerchChange(false)
		setserchString('')
	}
	const onSend = () => {
		setIsGroupNameSubmitted(true)
		if (!groupName) return
		setIsGroupNameEntered(true)
	}
	const onSerch = () => {
		mutateLoadCoWorkers(
			{
				is_search: 1,
				is_sort: 0,
				is_status: 0,
				limit_value: 50,
				start_from: 0,
				activity_type_category_id: 5,
				search_string: serchString,
			},
			{
				onSuccess: async data => {
					let val
					if (isFromGroup) {
						val = data.filter(
							val =>
								groupUsers.findIndex(
									ele =>
										ele.operating_asset_first_name ===
											val.operating_asset_first_name &&
										ele.operating_asset_phone_number ===
											JSON.parse(val.activity_inline_data).contact_phone_number
								) === -1
						)
					} else {
						val = data.filter(
							val =>
								groupList.findIndex(
									ele => ele.activity_id === val.activity_id
								) === -1
						)
					}
					setParticipantData(val)
				},
				onError: async err => {
					console.log('on search error ', err)
				},
			}
		)
	}
	const onAddGroup = () => {
		// typeof setchatView === 'function' && setchatView(CHAT_PANEL_VIEW.LIST_VIEW)
		setchatData([])
		setisGroupChat(true)
		setisSerchChange(true)
	}

	return (
		<Flex flexDirection='column' h='100%'>
			<Flex alignItems='center' justifyContent='space-between' bg='#FFFFFF'>
				<Flex
					alignItems='center'
					justifyContent='flex-start'
					p='20px 15px 15px 15px'
				>
					<Box
						display='flex'
						alignItems='center'
						justifyContent='center'
						cursor='pointer'
						marginRight='15px'
						onClick={onChatClose}
					>
						{/* <Image src={backArrowIcon} alt='backArrow icon' /> */}
						<SVGIcon
							iconName='BackArrowGreenSvg'
							svgProps={{
								width: '12',
								height: '20',
								viewBox: '0 0 12 20',
							}}
							// pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					<Box display='flex' flexDir='column' justifyContent='flex-start'>
						<Box fontSize='18px' fontWeight='500' color='#009B76'>
							{locale['Create Group']}
						</Box>
					</Box>
				</Flex>
			</Flex>

			<Divider />
			<Box
				display='flex'
				flexDir='column'
				overflowY='auto'
				overflowX='hidden'
				backgroundRepeat='no-repeat'
				backgroundPosition='center'
				backgroundSize='cover'
				position='relative'
				backgroundImage={`url(${bgImage})`}
				backgroundColor='#bbbbbb1a'
				borderLeft='0.5px solid #e0e0e0'
				flexGrow='1'
				sx={{
					'&::-webkit-scrollbar': {
						width: '8px',
						//backgroundColor: `rgb(0,155,118)`,
					},
					'&::-webkit-scrollbar-thumb': {
						backgroundColor: `rgb(0,155,118)`,
					},
					'&::-webkit-scrollbar-button': {
						height: '20px',
					},
				}}
			>
				{/* {chatData?.length > 0 &&
					chatData?.map((item, i, array) => {
						let msgDate = formatDDMMYYYY(item.datetime_log)
						let size = 3
						let showTag = true
						if (i === 0) {
							size = 3
						} else {
							let lastDate = formatDDMMYYYY(array[i - 1]?.datetime_log)
							if (msgDate === lastDate) {
								showTag = false
							} else {
								showTag = true
							}
							size =
								typeof item?.data_entity_inline === 'string'
									? item?.data_entity_inline.length
									: Object.keys(item?.data_entity_inline).length
						}

						return (
							<React.Fragment key={i}>
								{showTag && size > 2 ? (
									<Center>
										<Box
											bg='#F8FAFC'
											width='100px'
											height='30px'
											color='gray.400'
											padding='5px'
											mt='5px'
											mb='5px'
											fontSize='14px'
											fontWeight='400'
											borderRadius='55px'
											textAlign='center'
										>
											{formatChatGroupBy(item.datetime_log)}
										</Box>
									</Center>
								) : (
									''
								)}
								<SingleMessage
									// key={i + 1}
									index={i}
									messages={item}
									user={user}
									chanelName={userName}
									profileImage={profileImage}
								/>
								<div ref={messagesEndRef} />
							</React.Fragment>
						)
					})} */}

				<Box
					display='flex'
					alignItems='center'
					alignSelf='flex-start'
					justifyContent='flex-start'
					height='40px'
					px='20px'
					py='10px'
					bg='#FFFFFF'
					ml='35px'
					mt='25px'
					borderRadius='0px 12px 12px 12px'
				>
					{/* <Image
						src={greneIcon}
						maxW='2.25rem'
						display='inline-block'
						mr='10px'
					/> */}
					<Box mr='10px' display='inline-block'>
						<SVGIcon
							iconName='GreenLogoLineSvg'
							svgProps={{
								width: '36',
								height: '10',
								viewBox: '0 0 36 10',
							}}
							// pathProps={{ fill: '#009B76' }}
						/>
					</Box>
					<Box display='flex' fontSize='14px' fontWeight='400' color='#666'>
						{locale['Enter Group Name']}
					</Box>
				</Box>

				{isGroupNameEntered && !!groupName ? (
					<>
						<Box
							display='flex'
							flexDir='column'
							alignSelf='flex-end'
							alignItems='flex-start'
							justifyContent='center'
							mr='35px'
						>
							<Box
								display='flex'
								alignSelf='flex-end'
								alignItems='center'
								justifyContent='flex-start'
								height='50px'
								px='15px'
								py='10px'
								bg='#009B76'
								mt='25px'
								borderRadius='15px 15px 0px 15px'
							>
								<Box
									display='flex'
									fontSize='14px'
									fontWeight='400'
									color='white'
								>
									{groupName}
									<Text mt='5px' fontSize='12px' ml='8px'>
										{formatHHMM(getCurrentDateUTC())}
									</Text>
								</Box>
							</Box>
							<ButtonCTA
								alignSelf='center'
								variant='idcardButton'
								size='sm'
								fontSize='13px'
								fontWeight='500'
								bg='white'
								mt='22px'
								onClick={() => {
									// onAddGroup()
									addParticipantOnOpen()
								}}
							>
								{locale['Add Participants']}
							</ButtonCTA>
						</Box>
					</>
				) : null}
			</Box>
			{!isGroupNameEntered ? (
				<>
					<Box display='flex' p='5px 7px 0px 0px'>
						<Flex w='100%'>
							<InputText
								placeholder={locale['Enter Group Name']}
								_placeholder={{ color: '#969696' }}
								value={groupName}
								onChange={e => setGroupName(e.target.value)}
							/>
							<IconButton
								w='48px'
								h='40px'
								borderRadius='50%'
								bg='brand.700'
								color='#FFFFFF'
								variant=''
								aria-label='Search database'
								marginLeft='2'
								icon={<MdSend />}
								onClick={() => {
									sectionDetailedTrack({
										category: GA_CATEGORY_NAVBAR,
										action: 'Chat List',
										label: locale['Send'],
									})
									onSend()
								}}
							/>
						</Flex>
					</Box>
					{isGroupNameSubmitted && !groupName ? (
						<Text position='absolute' bottom='70px' color='red.400'>
							Please enter a Group Name
						</Text>
					) : null}
				</>
			) : null}

			<ParticipantDrawer
				headerText={locale['Add Participants']}
				isOpen={addParticipantFormIsOpen}
				onClose={addParticipantOnClose}
				selectedParticipant={selectedParticipants}
				setSelectedParticipant={setSelectedParticipants}
				onSubmit={onGroupCreat}
			/>
		</Flex>
	)
}

export default CreateGroupView
